import useGetGuidebookAccessUrl from './useGetGuidebookAccessUrl';

const useGetPropertyGuidebookAccessUrl = () => {
  const { getGuidebookAccessUrl, isFetching } = useGetGuidebookAccessUrl();

  const getPropertyGuidebookURL = async ({
    propertyUid,
  }: {
    propertyUid: string;
  }) => {
    const guidebookUrl = await getGuidebookAccessUrl();

    if (!guidebookUrl?.data?.url) {
      return null;
    }

    const hasQueryString = guidebookUrl.data.url.includes('?');
    const separator = hasQueryString ? '&' : '?';
    return `${guidebookUrl.data.url}${separator}propertyUid=${propertyUid}`;
  };

  return { getPropertyGuidebookURL, isFetching };
};

export default useGetPropertyGuidebookAccessUrl;
